export default __webpack_public_path__ + "static/media/charging-station-solid.91cdf1cf.svg";